import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const retailerFundedMarketingAdminAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess,
    Permission.RetailerFundedMarketingRetailerFundedMarketingModifyAccess,
  ],
}

export const retailerFundedMarketingAdminCustomCampaignAccessControl: DomainAccessControlConfig = [
  // Legacy stays on until v2 is enabled for this user
  {
    permissions: [Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess],
    notFeatureToggles: [FeatureToggle.marketingToolingEnabled],
  },
  // Override takes precedence: keep legacy even after v2 is enabled
  {
    permissions: [Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess],
    featureToggles: [FeatureToggle.marketingToolingV2DisabledOverride],
  },
]

// Permissive outer gate: lets any admin user enter the legacy campaigns route tree
// so per-page wrappers can decide whether to render or redirect to the new
// marketing-tooling version. Page-level access control lives in the wrappers.
export const retailerFundedMarketingAdminCampaignBaseAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess],
}
